const SECRET_KEY = "BID_GROUP_SECURE_KEY_2026";

/**
 * Encrypts a string (e.g. basic auth token) using XOR and encodes to Base64.
 */
export function encryptToken(text: string): string {
  if (!text) return "";
  let result = "";
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
    result += String.fromCharCode(charCode);
  }
  try {
    return btoa(result);
  } catch (e) {
    console.error("Base64 encryption encoding failed:", e);
    return "";
  }
}

/**
 * Decrypts a Base64 encoded string and XORs it back to the original text.
 */
export function decryptToken(encoded: string): string {
  if (!encoded) return "";
  try {
    const text = atob(encoded);
    let result = "";
    for (let i = 0; i < text.length; i++) {
      const charCode = text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
      result += String.fromCharCode(charCode);
    }
    // Return decrypted string if valid ASCII printable
    if (result && /^[\x20-\x7E]+$/.test(result)) {
      return result;
    }
    return encoded;
  } catch (e) {
    // If it's a raw un-encrypted token string, return it directly as fallback
    return encoded;
  }
}
